import React from "react"
import { FormattedMessage, injectIntl, defineMessages } from "react-intl"
import { Link } from "react-router-dom"
import ActivityFeedEventSearchResult from "../../../state/search/Dto"
import { Intl } from "../../../state/helpers/IntlProps"

type Props = {
    intl: Intl,
    activity: ActivityFeedEventSearchResult,
}

const messages = defineMessages({
    "order": {
        id: "dashboard.activity-feed.document_signed.order",
        defaultMessage: "Your order {identifier} was signed by {customer}",
    },
    "invoice": {
        id: "dashboard.activity-feed.document_signed.invoice",
        defaultMessage: "Your invoice {identifier} was signed by {customer}",
    },
    "contract": {
        id: "dashboard.activity-feed.document_signed.contract",
        defaultMessage: "Your contract {identifier} was signed by {customer}",
    },
    "quote": {
        id: "dashboard.activity-feed.document_signed.quote",
        defaultMessage: "Your quote {identifier} was signed by {customer}",
    },
})

const ActivityFeedEventDocumentSignedComponent = (props: Props) => {
    const parsedData = JSON.parse(props.activity.getObjectDataJson())
    const documentType = parsedData.documentType
    const content = parsedData.content

    const getObjectType = () => {
        if (props.activity.getObjectType() == "contracts") {
            return "quotes"
        }
        return props.activity.getObjectType()
    }

    return (
        <>
            <div>
                <FormattedMessage
                    {...messages[documentType]}
                    values={{
                        customer: <Link to={`/contacts/${props.activity.getContactId()}/details`}>
                            {props.activity.getContactName()}
                        </Link>,
                        identifier: <Link to={`/${getObjectType()}/${props.activity.getObjectId()}/edit`}>
                            {props.activity.getIdentifier()}
                        </Link>
                    }}
                />
                &nbsp;
                &nbsp;
            </div>
            <div className={"row pl-3"}>
                <div className={"w-100 mt-1"}>
                    <blockquote className="blockquote mb-0 bg-light py-3">
                        <p className="mb-0">
                            <FormattedMessage
                                id="dashboard.ActivityFeedEventDocumentSigned.message_document_proposal"
                                defaultMessage="Open your document from {proposalUrl}"
                                values={{
                                    proposalUrl: <a href={content}>
                                        {props.activity.getIdentifier()}
                                    </a>,
                                }}
                            />
                        </p>
                    </blockquote>
                </div>
            </div>
        </>
    )
}
export default injectIntl(ActivityFeedEventDocumentSignedComponent)



// WEBPACK FOOTER //
// ./src/dashboard/activity-feed/components/ActivityFeedEventDocumentSignedComponent.tsx